import React from 'react';
import ChatBox from './ChatBox';

const ChatBotIcon = ({ onExternalMessage, isOpen = false, onClose = () => {}, onToggle }) => {
  const handleToggle = () => {
    if (onToggle) {
      onToggle();
    }
  };

  return (
  <div className="fixed bottom-6 right-6 z-[99]">
    <button
      className="bg-[#e01f26] hover:bg-[#c01920] 
                 text-white rounded-full p-4 shadow-lg transform transition-all duration-300 
                 hover:scale-110 hover:shadow-xl flex items-center justify-center
                 w-16 h-16 sm:w-20 sm:h-20"
      onClick={handleToggle}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-12 w-12 sm:h-14 sm:w-14"
        viewBox="0 0 24 24"
        fill="none"
      >
        {/* Robot head outline */}
        <rect x="4" y="4" width="16" height="14" rx="2" fill="#222" stroke="white" strokeWidth="1" />
        
        {/* Robot face */}
        <rect x="7" y="8" width="10" height="6" rx="1" fill="#333" />
        
        {/* Robot eyes */}
        <circle cx="9" cy="11" r="1.5" fill="white" />
        <circle cx="15" cy="11" r="1.5" fill="white" />
        
        {/* Robot antenna */}
        <line x1="12" y1="4" x2="12" y2="2" stroke="white" strokeWidth="1.5" />
        <circle cx="12" cy="1.5" r="0.8" fill="white" />
        
        {/* Robot mouth/speaker */}
        <rect x="8" y="14" width="8" height="1.5" rx="0.75" fill="white" />
        
        {/* Robot neck */}
        <rect x="10" y="18" width="4" height="2" fill="#222" />
        
        {/* Robot ear pieces */}
        <rect x="3" y="10" width="1" height="4" rx="0.5" fill="#222" />
        <rect x="20" y="10" width="1" height="4" rx="0.5" fill="#222" />
        
        {/* Headset microphone */}
        <path d="M3 11C3 11 2 11 2 12V14C2 15 3 15 3 15" stroke="white" strokeWidth="1" />
        <circle cx="2" cy="15" r="0.6" fill="white" />
      </svg>
    </button>
    <ChatBox isOpen={isOpen} onClose={onClose} onExternalMessage={onExternalMessage} />
  </div>
);
};

export default ChatBotIcon;